/* eslint-disable */
/*
  oJo, no hacer multininea.

  oJo, poner raiz la categoría: ej.-
     Blockly.Msg["SENSOR_(nombre del mensaje)"]

  oJo, no sacar literales aunque se dupliquen (son pocas): ej.-
     Blockly.Msg["COPY_TO_BACKPACK"] = "Copiar a la motchila"; <- OK
     Blockly.Msg["COPY"] = "Copiar";                           <- NO OK
     Blockly.Msg["BACKPACK"] = "motchila";                     <- NO OK

  oJo, hacer las modificaciones en los 4 diomas a la vez!!!,
    la idea es que coincidan línea a línea,
    no dejar una traducción hecha en un idioma y no en el resto.
*/

import Blockly from "blockly";

export function AEU() {
  Blockly = {};
  Blockly.Msg = {};

  // Blocks - COMMON
  Blockly.Msg["ADD_NEW_LINE"] = "Lerro jauzia";
  Blockly.Msg["AS"] = "honela:";
  Blockly.Msg["BAUDRATE"] = "Baudio";
  Blockly.Msg["BOOLEAN_FALSE"] = "gezurra";
  Blockly.Msg["BOOLEAN_OFF"] = "OFF";
  Blockly.Msg["BOOLEAN_ON"] = "ON";
  Blockly.Msg["BOOLEAN_TRUE"] = "egia";
  Blockly.Msg["COL"] = "Zutabea";
  Blockly.Msg["COLOUR"] = "Kolorea";
  Blockly.Msg["DEFAULT_VAR_NAME"] = "ZenbAldag";
  Blockly.Msg["DO"] = "egin";
  Blockly.Msg["FIX"] = "Finkatu";
  Blockly.Msg["I2C_ADDRESS"] = "Helbidea";
  Blockly.Msg["I2C_BEGIN"] = "Hasi (I2C)";
  Blockly.Msg["ID"] = "#";
  Blockly.Msg["PIN"] = "PIN";
  Blockly.Msg["ROW"] = "Errenkada";
  Blockly.Msg["STATUS"] = "Egoera";
  Blockly.Msg["TIMEOUT"] = "gehieneko denbora";
  Blockly.Msg["UNTIL_NEW_LINE"] = "Lerro jauzira arte";
  Blockly.Msg["VALUE"] = "Balioa";
  Blockly.Msg["UPLOAD"] = "Upload"; // OjO, sin traducir

  // Blocks - LOGIC
  Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = Blockly.Msg["BOOLEAN_FALSE"];
  Blockly.Msg["LOGIC_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LOGIC_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Egia edo gezurra itzultzen du.";
  Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = Blockly.Msg["BOOLEAN_TRUE"];
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Egia itzultzen du bi sarrerak berdinak baldin badira.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Egia itzultzen du lehen sarrera bigarren sarrera baino handiagoa bada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Egia itzultzen du lehen sarrera bigarren sarrera baino handiagoa edo haren berdina bada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Egia itzultzen du lehen sarrera bigarren sarrera baino txikiagoa bada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Egia itzultzen du lehen sarrera bigarren sarrera baino txikiagoa edo haren berdina bada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Egia itzultzen du bi sarrerak desberdinak badira.";
  Blockly.Msg["LOGIC_NEGATE_TITLE"] = "ez %1";
  Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Egia itzultzen du sarrera gezurra bada. Gezurra itzultzen du sarrera egia bada.";
  Blockly.Msg["LOGIC_OPERATION_AND"] = "eta";
  Blockly.Msg["LOGIC_OPERATION_OR"] = "edo";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Egia itzultzen du bi sarrerak egiak badira.";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Egia itzultzen du sarreretako bat gutxienez egia bada.";
  Blockly.Msg["LOGIC_IF_MSG_ELSE"] = "betetzen ez bada";
  Blockly.Msg["LOGIC_IF_MSG_ELSEIF"] = "betetzen ez bada, baldin";
  Blockly.Msg["LOGIC_IF_MSG_IF"] = "Baldin";
  Blockly.Msg["LOGIC_IF_MSG_THEN"] = Blockly.Msg["DO"];
  Blockly.Msg["LOGIC_IF_TOOLTIP"] = "Konparaketa egia bada, lotutako blokeak exekutatzen ditu.";

  // Blocks - CONTROLS
  Blockly.Msg["CONTROLS_FOR_TITLE"] = "Zenbatu %1(r)ekin %2(e)tik %3 arte %4naka";
  Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = '"%1" aldagaiak hasierako zenbakitik amaierako zenbakira arteko balioak har ditzan eragitea, zehaztutako tartearekin zenbatuz, eta zehaztutako blokeak egin.';
  Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "Errepikatu %1 aldiz";
  Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Egin adierazpen batzuk zenbait aldiz.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "Errepikatu izan arte";
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "Errepikatu iraun bitartean";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "Balio bat gezurra den bitartean, egin ekintza batzuk.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "Balio bat egia den bitartean, egin ekintza batzuk.";
  Blockly.Msg["CONTROLS_ARDUINO_LOOP"] = "Begizta";
  Blockly.Msg["CONTROLS_ARDUINO_SETUP"] = "Abiarazi";
  Blockly.Msg["CONTROLS_GROUP"] = "Multzokatu";

  // Blocks - MATH
  Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
  Blockly.Msg["MATH_ANGLE"] = "angelua";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Bi zenbakien batura itzultzen du.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Bi zenbakien zatidura itzultzen du.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Bi zenbakien kendura itzultzen du.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Bi zenbakien biderkadura itzultzen du.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Lehen zenbakia ber bigarren zenbakia itzultzen du. ";
  Blockly.Msg["MATH_CHANGE_TITLE"] = "Aldatu %1 gehitu %2";
  Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["MATH_CHANGE_TOOLTIP"] = 'Gehitu zenbaki bat aldagai honi «%1».';
  Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "mugatu %1 hauen artean %2 eta %3";
  Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Mugatu zenbaki bat zehaztutako mugen artean (biak barne).";
  Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";
  Blockly.Msg["MATH_MAP_TITLE"] = "mapatu %1 hemendik %2 - %3 hona %4 - %5";
  Blockly.Msg["MATH_MAP_TOOLTIP"] = "Mapatu zenbaki bat hein batetik beste batera";
  Blockly.Msg["MATH_MODULO_TITLE"] = "Honen hondarra %1 ÷ %2";
  Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Bi zenbakiak zatituta geratzen den hondarra itzultzen du.";
  Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";
  Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "Zenbaki bat.";
  Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
  Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "osoa, ausazkoa %1 eta %2 artean";
  Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Zehaztutako bi mugen baitan (biak barne) dagoen ausazko zenbaki oso bat itzultzen du.";
  Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolutua";
  Blockly.Msg["MATH_SINGLE_OP_LN"] = "log(e)";
  Blockly.Msg["MATH_SINGLE_OP_LOG10"] = "log(10)";
  Blockly.Msg["MATH_SINGLE_OP_NEG"] = "-";
  Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "erro karratua";
  Blockly.Msg["MATH_SINGLE_OP_ROUND"] = "biribildu";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDDOWN"] = "biribildu beherantz";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDUP"] = "biribildu gorantz";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Zenbaki baten balio absolutua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "e ber zenbaki bat itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Zenbaki baten logaritmo naturala itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Zenbaki baten 10 oinarriko logaritmoa itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Zenbaki baten ukapena itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Zenbaki baten erro karratua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Zenbaki baten 10 oinarriko berreketa itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUND"] = "Zenbaki bat gorantz edo beherantz biribiltzea.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDUP"] = "Zenbaki bat gorantz biribiltzea.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDDOWN"] = "Zenbaki bat beherantz biribiltzea.";
  Blockly.Msg["MATH_SINGLE_TRIG_ACOS"] = "acos";
  Blockly.Msg["MATH_SINGLE_TRIG_ASIN"] = "asin";
  Blockly.Msg["MATH_SINGLE_TRIG_ATAN"] = "atan";
  Blockly.Msg["MATH_SINGLE_TRIG_COS"] = "cos";
  Blockly.Msg["MATH_SINGLE_TRIG_SIN"] = "sin";
  Blockly.Msg["MATH_SINGLE_TRIG_TAN"] = "tan";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ACOS"] = "Zenbaki baten arku kosinua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ASIN"] = "Zenbaki baten arku sinua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ATAN"] = "Zenbaki baten arku tangentea itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_COS"] = "Gradu baten (ez radiana) kosinua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_SIN"] = "Gradu baten (ez radiana) sinua itzultzen du.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_TAN"] = "Gradu baten (ez radiana) tangentea itzultzen du.";
  Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
  Blockly.Msg["MATH_TO_INT"] = "zenbaki osoa";
  Blockly.Msg["MATH_TO_UINT"] = "zenbaki osoa zeinurik gabe";
  Blockly.Msg["MATH_TRIG_ATAN2"] = "atan2";
  Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN2"] = "y/x-ren arku tangentea itzultzen du.";

  // Vlocks - TEXT
  Blockly.Msg["TEXT_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["TEXT_ASCII"] = "ASCII balioa";
  Blockly.Msg["TEXT_CONTAINS"] = "testu honen barruan dago";
  Blockly.Msg["TEXT_CONTAINS_1"] = "katea";
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Gehitu elementu bat testuari.";
  Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "lotu";
  Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Gehitu, ezabatu edo berrantolatu atalak testu bloke hau berriz konfiguratzeko.";
  Blockly.Msg["TEXT_DECIMAL"] = "hamartarrak";
  Blockly.Msg["TEXT_ENDSWITH"] = "honela amaitzen da";
  Blockly.Msg["TEXT_EQUALS"] = "honen berdina";
  Blockly.Msg["TEXT_EQUALS_IGNORE"] = "honen berdina (letra larriak kontuan hartu gabe)";
  Blockly.Msg["TEXT_FORMAT"] = "eman formatua zenbakiari";
  Blockly.Msg["TEXT_INDEXOF"] = "bilatu testuan";
  Blockly.Msg["TEXT_INDEXOF_1"] = "katea";
  Blockly.Msg["TEXT_INDEXOF_FIRST"] = "lehena";
  Blockly.Msg["TEXT_INDEXOF_LAST"] = "azkena";
  Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "sortu testua hauekin";
  Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Testu zati bat sortu edozein elementu kopuru lotzean.";
  Blockly.Msg["TEXT_LENGTH_TITLE"] = "luzera %1";
  Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Emandako testuan dagoen letra kopurua itzultzen du (zuriuneak barne).";
  Blockly.Msg["TEXT_NOT_EQUALS"] = "honen desberdina";
  Blockly.Msg["TEXT_REPLACE"] = "Ordeztu testuan";
  Blockly.Msg["TEXT_REPLACE_1"] = "katea";
  Blockly.Msg["TEXT_REPLACE_2"] = "ordezkoa";
  Blockly.Msg["TEXT_STARTSWITH"] = "honela hasten da";
  Blockly.Msg["TEXT_SUBSTRING"] = "zatitu testua";
  Blockly.Msg["TEXT_SUBSTRING_1"] = "hasiera";
  Blockly.Msg["TEXT_SUBSTRING_2"] = "amaiera";
  Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Letra, hitza edo testu lerroa.";
  Blockly.Msg["TEXT_TONUMBER"] = "testutik zenbakira";
  Blockly.Msg["TEXT_WITH"] = "honekin";

  // Blocks - VARIABLES
  Blockly.Msg["VARIABLES_DEFAULT_NAME"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["VARIABLES_DEFAULT_NAME_BOOL"] = "AldagBool";
  Blockly.Msg["VARIABLES_DEFAULT_NAME_TEXT"] = "TestuAldag";
  Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Sortu '%1 ezarri'";
  Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Aldagai honen balioa itzultzen du.";
  Blockly.Msg["VARIABLES_SET"] = "Ezarri";
  Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Sortu '%1 lortu'";
  Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Aldagai hau ezartzen du sarreraren berdina izan dadin.";

  // Blocks - LISTS
  Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "zerrenda hutsa";
  Blockly.Msg["LISTS_CREATE_TITLE"] = "Sortu zerrenda %1 %2 %3";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_NUMBER_WITH"] = "zenbakia ";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_TEXT_WITH"] = "testua ";
  Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Sortu zerrenda bat adierazitako elementuekin.";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "Sortu zenbaki zerrenda";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH_TEXT"] = "Sortu testu zerrenda";
  Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["LISTS_GET_INDEX_GET"] = "lortu elementua";
  Blockly.Msg["LISTS_GET_INDEX_TOOLTIP"] = "Elementua adierazitako indizean itzultzen du.";
  Blockly.Msg["LISTS_SET_INDEX_TOOLTIP"] = "Elementua adierazitako indizean ezartzen du.";
  Blockly.Msg["LISTS_LENGTH_TITLE"] = "luzera ";
  Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Zerrenda baten luzera itzultzen du.";
  Blockly.Msg["LISTS_LISTNAME"] = "ZenbakiZer";
  Blockly.Msg["LISTS_LISTNAME_TEXT"] = "TestuZer";
  Blockly.Msg["LISTS_SET_INDEX_SET"] = "ezarri elementua";

  // Blocks - PROCEDURES
  Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "Ahalbidetu adierazpenak";
  Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "honekin";
  Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "erabiltzaileak definitutako '%1' funtzioa exekutatzen du.";
  Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "erabiltzaileak definitutako '%1' funtzioa exekutatzen du eta haren irteera erabiltzen du.";
  Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "honekin";
  Blockly.Msg["PROCEDURES_CREATE_DO"] = "'%1’ sortu ";
  Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Funtzio hau deskribatzen du…";
  Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
  Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "Zerbait egiteko";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "Honetarako ";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Irteerarik gabeko funtzio bat sortzen du.";
  Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "itzultzen du";
  Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Funtzio bat sortzen du irteera batekin.";
  Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Oharra: Funtzio honek parametro bikoiztuak ditu.";
  Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Nabarmendu funtzioaren definizioa";
  Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Balio bat egia baldin bada, balioa itzultzen du.";
  Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Abisua: Bloke hau funtzioaren definizio barruan soilik erabil daiteke.";
  Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "sarreraren izena ";
  Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Gehitu sarrera bat funtzioari.";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "sarrerak";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Gehitu, ezabatu edo berrantolatu sarrerak funtzio honetarako.";
  Blockly.Msg["PROCEDURES_VARIABLE"] = "argumentua:";
  Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
  Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
  Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
  Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];

  // Blocks - IO
  Blockly.Msg["IO_ANALOG_READ"] = "Irakurri PIN analogikoa";
  Blockly.Msg["IO_ANALOG_READ_DIF"] = "Irakurri analogiko diferentziala";
  Blockly.Msg["IO_ANALOG_WRITE"] = "Idatzi PWM PIN analogikoa";
  Blockly.Msg["IO_CAPACITIVE_READ"] = "Irakurri sarrera kapazitiboa";
  Blockly.Msg["IO_DIGITAL_READ"] = "Irakurri PIN digitala";
  Blockly.Msg["IO_DIGITAL_WRITE"] = "Idatzi PIN digitala";
  Blockly.Msg["IO_INTERRUPT"] = "Etena";
  Blockly.Msg["IO_INT_RISING"] = "Igoera";
  Blockly.Msg["IO_INT_FALLING"] = "Jaitsiera";
  Blockly.Msg["IO_INT_CHANGE"] = "Aldaketa";
  Blockly.Msg["IO_INT_LOW"] = "Txikia";
  Blockly.Msg["IO_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IO_PINMODE"] = "Konfiguratu PINa";
  Blockly.Msg["IO_PINMODE_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["IO_PULSEIN"] = "Irakurri pultsua";
  Blockly.Msg["IO_PULSEIN_TIMEOUT"] = "Itxarote denbora";
  Blockly.Msg["IO_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - TIME
  Blockly.Msg["TIME_MICROS"] = "mikrosegundo";
  Blockly.Msg["TIME_MILLIS"] = "milisegundo";
  Blockly.Msg["TIME_SECONDS"] = "segundo";
  Blockly.Msg["TIME_RUNEVERYMS"] = "Denbora honetan, behin exekutatu";
  Blockly.Msg["TIME_SNOOZE"] = "Lo egin";
  Blockly.Msg["TIME_TIMER"] = "Kronometroa";
  Blockly.Msg["TIME_TIMER_RESET"] = "Berrabiarazi kronometroa";
  Blockly.Msg["TIME_TIME_ELAPSED_SECONDS"] = "Pasatutako denbora segundotan";
  Blockly.Msg["TIME_TIME_ELAPSED_MILLI"] = "Pasatutako denbora milisegundotan";
  Blockly.Msg["TIME_TIME_ELAPSED_MICRO"] = "Pasatutako denbora mikrosegundotan";
  Blockly.Msg["TIME_WAIT"] = "Itxaron";
  Blockly.Msg["TIME_WAIT_FOREVER"] = "Itxaron betiko (bukaera)";
  Blockly.Msg["TIME_WAIT_UNTIL"] = "Itxaron izan arte";
  Blockly.Msg["TIME_WAIT_WHILE"] = "Itxaron iraun bitartean";

  // Blocks - SERIAL
  Blockly.Msg["SERIAL_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SERIAL_AVAILABLE"] = "Datuak jasota?";
  Blockly.Msg["SERIAL_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["SERIAL_FLUSH"] = "Hustu datuak";
  Blockly.Msg["SERIAL_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["SERIAL_INIT"] = "Hasi";
  Blockly.Msg["SERIAL_INT"] = "Gertakaria atakan";
  Blockly.Msg["SERIAL_PLOT_CREATE_TITLE"] = "Serieko ataka %1 Grafikoa: %2 %3";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NAME"] = "izena ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NUMBER"] = "balioa ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_TOOLTIP"] = "Edozein seinale kopurutarako grafikoa";
  Blockly.Msg["SERIAL_PLOT_CREATE_EMPTY_TITLE"] = "grafiko hutsa";
  Blockly.Msg["SERIAL_PRINT"] = "Bidali";
  Blockly.Msg["SERIAL_PRINTLN"] = "Bidali lerroa";
  Blockly.Msg["SERIAL_READ"] = "Jaso";
  Blockly.Msg["SERIAL_READBYTE"] = "Jaso bytea";
  Blockly.Msg["SERIAL_READFLOAT"] = "Jaso zenbaki gisa";
  Blockly.Msg["SERIAL_READINT"] = "Jaso zenbaki oso gisa";
  Blockly.Msg["SERIAL_READSTRING"] = "Jaso testua";
  Blockly.Msg["SERIAL_READSTRINGLINE"] = "Jaso testu lerroa";
  Blockly.Msg["SERIAL"] = "Serieko ataka";
  Blockly.Msg["SERIAL_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["SERIAL_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["SERIAL_WRITEBYTE"] = "Bidali bytea";

  // Blocks - SENSOR
  Blockly.Msg["SENSOR_ACCEL_ADXL345"] = "Azelerometroa (ADXL345)";
  Blockly.Msg["SENSOR_ACCEL_OFFSET"] = "Konpentsatu";
  Blockly.Msg["SENSOR_BUTTON"] = "Sakagailua";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED"] = "Sakagailu iragazia";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_PRESSED"] = "sakatu da";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_RELEASED"] = "askatu da";
  Blockly.Msg["SENSOR_BUTTON_INVERT"] = "Logika alderantzikatua";
  Blockly.Msg["SENSOR_DHT11"] = "Giroko sentsorea (DHT-11)";
  Blockly.Msg["SENSOR_DHT22"] = "Giroko sentsorea (DHT-22)";
  Blockly.Msg["SENSOR_HUMIDITY"] = "Hezetasuna %";
  Blockly.Msg["SENSOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SENSOR_POT"] = "Potentziometroa";
  Blockly.Msg["SENSOR_SOUND"] = "Mikrofonoa";
  Blockly.Msg["SENSOR_TEMPERATURE"] = "Tenperatura ºC";
  Blockly.Msg["SENSOR_TEMT6000"] = "Argi sentsorea (TEMT6000)";
  Blockly.Msg["SENSOR_TILT"] = "Inklinazio sentsorea (TILT)";
  Blockly.Msg["SENSOR_TMP36"] = "Tenperatura sentsorea (TMP36)";
  Blockly.Msg["SENSOR_ULTRASONIC"] = "Distantzia sentsorea (HCSR-04)";
  Blockly.Msg["SENSOR_ULTRASONIC_MAXDISTANCE"] = "Max (cm)";
  Blockly.Msg["SENSOR_ULTRASONIC_UNITS"] = "Unitateak";

  // Blocks - ACTUATOR
  Blockly.Msg["ACTUATOR_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["ACTUATOR_COMMON_ANODE"] = "Anodo komuna";
  Blockly.Msg["ACTUATOR_COMMON_CATHODE"] = "Katodo komuna";
  Blockly.Msg["ACTUATOR_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["ACTUATOR_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["ACTUATOR_BUZZER"] = "Burrunbagailua";
  Blockly.Msg["ACTUATOR_BUZZER_DURATION"] = "Iraupena";
  Blockly.Msg["ACTUATOR_BUZZER_FREQ"] = "Maiztasuna";
  Blockly.Msg["ACTUATOR_BUZZER_TONE"] = "Tonua";
  Blockly.Msg["ACTUATOR_NOTE_A"] = "LA";
  Blockly.Msg["ACTUATOR_NOTE_AS"] = "LA#";
  Blockly.Msg["ACTUATOR_NOTE_B"] = "SI";
  Blockly.Msg["ACTUATOR_NOTE_C"] = "DO";
  Blockly.Msg["ACTUATOR_NOTE_CS"] = "DO#";
  Blockly.Msg["ACTUATOR_NOTE_D"] = "RE";
  Blockly.Msg["ACTUATOR_NOTE_DS"] = "RE#";
  Blockly.Msg["ACTUATOR_NOTE_E"] = "MI";
  Blockly.Msg["ACTUATOR_NOTE_F"] = "FA";
  Blockly.Msg["ACTUATOR_NOTE_FS"] = "FA#";
  Blockly.Msg["ACTUATOR_NOTE_G"] = "SOL";
  Blockly.Msg["ACTUATOR_NOTE_GS"] = "SOL#";
  Blockly.Msg["ACTUATOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["ACTUATOR_LED"] = "Leda";
  Blockly.Msg["ACTUATOR_LED_PWM"] = "Leda (PWM)";
  Blockly.Msg["ACTUATOR_RGBLED"] = "RGB Leda";
  Blockly.Msg["ACTUATOR_SOUND_PLAY"] = "Erreproduzitu";
  Blockly.Msg["ACTUATOR_STATUS"] = Blockly.Msg["STATUS"];
  Blockly.Msg["ACTUATOR_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - LCD
  Blockly.Msg["LCD"] = "LCD pantaila";
  Blockly.Msg["LCD_BACKLIGHT"] = "Atzealdeko argia";
  Blockly.Msg["LCD_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LCD_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LCD_BLINK"] = "Keinu";
  Blockly.Msg["LCD_CLEAR"] = "Garbitu";
  Blockly.Msg["LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["LCD_CURSOR"] = "Kurtsorea";
  Blockly.Msg["LCD_DEFINE"] = "Definitu";
  Blockly.Msg["LCD_DISPLAY"] = "Erakutsi";
  Blockly.Msg["LCD_EDITOR"] = "Sinbolo editorea";
  Blockly.Msg["LCD_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LCD_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LCD_LEFT"] = "Ezkerrera";
  Blockly.Msg["LCD_RIGHT"] = "Eskuinera";
  Blockly.Msg["LCD_PRINT"] = "Inprimatu";
  Blockly.Msg["LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["LCD_SCROLL"] = "Mugitu";
  Blockly.Msg["LCD_SYMBOL"] = "sinboloa";
  Blockly.Msg["LCD_SYMBOL_UPCASE"] = "Sinboloa";

  // Blocks - MATRIX
  Blockly.Msg["LEDMATRIX"] = "LED 8x8 matrizea";
  Blockly.Msg["LEDMATRIX_CLEAR"] = "Garbitu";
  Blockly.Msg["LEDMATRIX_DRAWBITMAP"] = "Bitmap";
  Blockly.Msg["LEDMATRIX_DRAWCIRCLE"] = "Zirkulua";
  Blockly.Msg["LEDMATRIX_DRAWPIXEL"] = "Pixela";
  Blockly.Msg["LEDMATRIX_DRAWTEXT"] = "Testua";
  Blockly.Msg["LEDMATRIX_EDITOR"] = "Bitmap editorea";
  Blockly.Msg["LEDMATRIX_FILL"] = "Bete";
  Blockly.Msg["LEDMATRIX_HEIGHT"] = "Altuera";
  Blockly.Msg["LEDMATRIX_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["LEDMATRIX_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LEDMATRIX_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LEDMATRIX_INIT"] = "Hasi";
  Blockly.Msg["LEDMATRIX_LED_ON"] = "Leda ON";
  Blockly.Msg["LEDMATRIX_LED_OFF"] = "Leda OFF";
  Blockly.Msg["LEDMATRIX_LINE"] = "Lerroa";
  Blockly.Msg["LEDMATRIX_RECTANGLE"] = "Laukizuzena";
  Blockly.Msg["LEDMATRIX_ROTATION"] = "Biratu";
  Blockly.Msg["LEDMATRIX_ROUND"] = "Biribildu";
  Blockly.Msg["LEDMATRIX_SHOW"] = "Erakutsi";
  Blockly.Msg["LEDMATRIX_WIDTH"] = "Zabalera";

  // Blocks - NEOPIXEL
  Blockly.Msg["NEOPIXEL"] = "NeoPixel";
  Blockly.Msg["NEOPIXEL_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["NEOPIXEL_CLEAR"] = "Garbitu";
  Blockly.Msg["NEOPIXEL_INIT"] = "Hasi";
  Blockly.Msg["NEOPIXEL_LEDCOUNT"] = "Led kopurua";
  Blockly.Msg["NEOPIXEL_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["NEOPIXEL_PIXEL"] = "Pixela";
  Blockly.Msg["NEOPIXEL_SETMATRIX"] = "Ezarri matrizea";
  Blockly.Msg["NEOPIXEL_SETPIXEL"] = "Ezarri leda";
  Blockly.Msg["NEOPIXEL_SETRAW"] = "Ezarri datuak";
  Blockly.Msg["NEOPIXEL_SHOW"] = "Erakutsi";
  Blockly.Msg["NEOPIXEL_EXAMPLES"] = "Adibideak";
  Blockly.Msg["NEOPIXEL_SPEED"] = "Abiadura";
  Blockly.Msg["NEOPIXEL_UNITS"] = "ms";
  Blockly.Msg["NEOPIXEL_COLOUR"] = "Kolorea";
  Blockly.Msg["NEOPIXEL_RED"] = "R";
  Blockly.Msg["NEOPIXEL_GREEN"] = "G";
  Blockly.Msg["NEOPIXEL_BLUE"] = "B";
  Blockly.Msg["NEOPIXEL_RAINBOW"] = "Ortzadarra";
  Blockly.Msg["NEOPIXEL_THEATER"] = "Antzokia";
  Blockly.Msg["NEOPIXEL_WIPE"] = "Garbitu";
  Blockly.Msg["NEOPIXEL_CHASE"] = "Distira";
  Blockly.Msg["NEOPIXEL_BRIGHTNESS"] = "Distira";

  // Blocks - MOTOR
  Blockly.Msg["MOTOR_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["MOTOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["MOTOR_SERVO"] = "Serbo";
  Blockly.Msg["MOTOR_SERVO_DEGREE_RANGE"] = "Graduak";
  Blockly.Msg["MOTOR_SERVO_DELAY"] = "Atzerapena";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR"] = "Osziladorea";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_AMPLITUDE"] = "Anplitudea";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_OFFSET"] = "Desfasea";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PERIOD"] = "Periodoa (ms)";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PHASE"] = "Fasea";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_REFRESH"] = "Eguneratu";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_RESET"] = "Berrabiarazi";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_START"] = "Hasi";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_STOP"] = "Gelditu";
  Blockly.Msg["MOTOR_STEPPER"] = "Motorra pausoz pauso";
  Blockly.Msg["MOTOR_STEPPER_RPM"] = "bira/min";
  Blockly.Msg["MOTOR_STEPPER_SPEED"] = "Abiadura";
  Blockly.Msg["MOTOR_STEPPER_START"] = "Hasi";
  Blockly.Msg["MOTOR_STEPPER_STEP"] = "Pausoak";
  Blockly.Msg["MOTOR_STEPPER_STEPS"] = "Pausoak/Buelta";
  Blockly.Msg["MOTOR_DC_MOTOR_DC"] = "DC Motorra";
  Blockly.Msg["MOTOR_DC_MOTOR"] = "Motorra";
  Blockly.Msg["MOTOR_DC_BEGIN"] = "Abiarazi";
  Blockly.Msg["MOTOR_DC_STOP"] = "Gelditu";
  Blockly.Msg["MOTOR_DC_DIRECTION"] = "Noranzkoa";
  Blockly.Msg["MOTOR_DC_FORDWARD"] = "Aurrera";
  Blockly.Msg["MOTOR_DC_SPEED"] = "Abiadura";
  Blockly.Msg["MOTOR_DC_BACKWARD"] = "Atzera";

  // Blocks - RTC
  Blockly.Msg["RTC"] = "Erloju digitala";
  Blockly.Msg["RTC_DATE_TEXT"] = "Data";
  Blockly.Msg["RTC_DAY"] = "Eguna";
  Blockly.Msg["RTC_DAYOFWEEK"] = "Asteko eguna";
  Blockly.Msg["RTC_FRIDAY"] = "Ostirala";
  Blockly.Msg["RTC_HOUR"] = "Ordua";
  Blockly.Msg["RTC_MINUTE"] = "Minutua";
  Blockly.Msg["RTC_MONDAY"] = "Astelehena";
  Blockly.Msg["RTC_MONTH"] = "Hilabetea";
  Blockly.Msg["RTC_SATURDAY"] = "Larunbata";
  Blockly.Msg["RTC_SECOND"] = "Segundoa";
  Blockly.Msg["RTC_SUNDAY"] = "Igandea";
  Blockly.Msg["RTC_THURSDAY"] = "Osteguna";
  Blockly.Msg["RTC_TIME_TEXT"] = "Ordua";
  Blockly.Msg["RTC_TUESDAY"] = "Asteartea";
  Blockly.Msg["RTC_WEDNESDAY"] = "Asteazkena";
  Blockly.Msg["RTC_YEAR"] = "Urtea";

  // Blocks - SD
  Blockly.Msg["SD"] = "SD txartela";
  Blockly.Msg["SD_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["SD_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SD_BEGIN"] = "Hasi";
  Blockly.Msg["SD_EXISTS"] = "Existitzen da fitxategia?";
  Blockly.Msg["SD_POS"] = "Posizioa";
  Blockly.Msg["SD_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SD_PRINT"] = "Datuen fitxategiak";
  Blockly.Msg["SD_FILE"] = "Fitxategia";
  Blockly.Msg["SD_READBYTE"] = "Irakurri bytea";
  Blockly.Msg["SD_READLOOP"] = "Irakurri byte bakoitza";
  Blockly.Msg["SD_REMOVE"] = "Ezabatu fitxategia";
  Blockly.Msg["SD_SIZE"] = "Fitxategiaren tamaina";
  Blockly.Msg["SD_WRITEBYTE"] = "Idatzi bytea";
  Blockly.Msg["SD_FORMAT"] = "Eman formatua";
  Blockly.Msg["SD_FORMAT_QUICK"] = "Eman formatu azkarra";
  Blockly.Msg["SD_ERASE"] = "Ezabatu";
  Blockly.Msg["SD_WRITE"] = "Idatzi";

  // Blocks - BLUETOOTH
  Blockly.Msg["BLUETOOTH"] = "Bluetooth";
  Blockly.Msg["BLUETOOTH_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_AVAILABLE"] = "Datuak jasota?";
  Blockly.Msg["BLUETOOTH_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLUETOOTH_DEVNAME"] = "Aldatu izena";
  Blockly.Msg["BLUETOOTH_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["BLUETOOTH_INIT"] = "Hasi";
  Blockly.Msg["BLUETOOTH_PIN"] = "PIN kodea";
  Blockly.Msg["BLUETOOTH_PRINT"] = "Bidali";
  Blockly.Msg["BLUETOOTH_PRINTLN"] = "Bidali testu lerroa";
  Blockly.Msg["BLUETOOTH_READBYTE"] = "Jaso bytea";
  Blockly.Msg["BLUETOOTH_READFLOAT"] = "Jaso zenbaki gisa";
  Blockly.Msg["BLUETOOTH_READSTRING"] = "Jaso testua";
  Blockly.Msg["BLUETOOTH_READSTRINGLINE"] = "Jaso testu lerroa";
  Blockly.Msg["BLUETOOTH_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["BLUETOOTH_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_WRITEBYTE"] = "Bidali bytea";

  // Blocks - BLYNK BLYNK_WIFI
  Blockly.Msg["BLYNK_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLYNK_APP_CONNECTED"] = "Appa konektatuta";
  Blockly.Msg["BLYNK_APP_DISCONNECTED"] = "Appa deskonektatuta";
  Blockly.Msg["BLYNK_APP_READ"] = "Eskatutako balioa";
  Blockly.Msg["BLYNK_APP_WRITE"] = "Jasotako balioa";
  Blockly.Msg["BLYNK_AUTH"] = "Autentifikazio kodea";
  Blockly.Msg["BLYNK_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLYNK_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["BLYNK_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["BLYNK_CONNECTED"] = "Zerbitzarira konektatuta";
  Blockly.Msg["BLYNK_INIT"] = "Hasi";
  Blockly.Msg["BLYNK_LCD_CLEAR"] = "Garbitu";
  Blockly.Msg["BLYNK_LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["BLYNK_LCD_PRINT"] = "Inprimatu";
  Blockly.Msg["BLYNK_LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["BLYNK_LED"] = "Leda";
  Blockly.Msg["BLYNK_LED_INTENSITY"] = "Distira";
  Blockly.Msg["BLYNK_LOCALPORT"] = "Ataka";
  Blockly.Msg["BLYNK_LOCALSERVER"] = "Zerbitzariaren IPa";
  Blockly.Msg["BLYNK_GPS"] = "Lokalizazio GPSa";
  Blockly.Msg["BLYNK_GPS_LAT"] = "Latitudea";
  Blockly.Msg["BLYNK_GPS_LONG"] = "Longitudea";
  Blockly.Msg["BLYNK_PARAM_READ_INT"] = "PINaren balioa";
  Blockly.Msg["BLYNK_PARAM_READ_STRING"] = "Testuaren balioa";
  Blockly.Msg["BLYNK_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["BLYNK_SET_PROPERTY"] = "Finkatu jabetza";
  Blockly.Msg["BLYNK_TERMINAL_CLEAR"] = "Garbitu";
  Blockly.Msg["BLYNK_TERMINAL_PRINT"] = "Inprimatu";
  Blockly.Msg["BLYNK_TIMER"] = "Tenporizadorea";
  Blockly.Msg["BLYNK_VIRTUALWRITE"] = "Idatzi PINa";
  Blockly.Msg["BLYNK_VPIN_VALUE"] = "Balioa";
  Blockly.Msg["BLYNK_WIFI"] = "Wifi";
  Blockly.Msg["BLYNK_WIFI_NAME"] = "SSID";
  Blockly.Msg["BLYNK_WIFI_PASS"] = "Pasahitza";

  // Blocks - IFTTT OjO, sin traducir
  Blockly.Msg["IFTTT_WEBHOOKS_KEY"] = "Webhooks Key: ";
  Blockly.Msg["IFTTT_EMAIL_TITLE"] = "Wifi %1 Email event: %2 %3";
  Blockly.Msg["IFTTT_EMAIL_TOOTLTIP"] = "Email with values";
  Blockly.Msg["IFTTT_EMAIL_VALUE"] = "value ";
  Blockly.Msg["IFTTT_SMS_EVENT"] = "SMS event:";
  Blockly.Msg["IFTTT_TWEET_EVENT"] = "Tweet event:";
  Blockly.Msg["IFTTT_TELEGRAM_EVENT"] = "Telegram event:";

  // Blocks - THINGER OjO, sin traducir
  Blockly.Msg["THINGER_USERID"] = "User ID: ";
  Blockly.Msg["THINGER_DEVICEID"] = "Device ID: ";
  Blockly.Msg["THINGER_AUTH"] = "Authorization: ";
  Blockly.Msg["THINGER_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGER_UPLOAD"] = Blockly.Msg["UPLOAD"];
  Blockly.Msg["THINGER_UPLOAD_TOOLTIP"] = "Upload any number of values";

  // Blocks - THINGSPEAK OjO, sin traducir
  Blockly.Msg["THINGSPEAK_WRITE_APIKEY"] = "Write API Key: ";
  Blockly.Msg["THINGSPEAK_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGSPEAK_UPLOAD_FIELD"] = "field ";

  // Blocks - MQTT (no publicado)
  Blockly.Msg["MQTT_BROKER"] = "Broker";
  Blockly.Msg["MQTT_CLIENTID"] = "Bezeroaren Ida";
  Blockly.Msg["MQTT_INIT"] = "Hasi";
  Blockly.Msg["MQTT_ISCONNECTED"] = "konektatuta dago?";
  Blockly.Msg["MQTT_MAC"] = "MAC";
  Blockly.Msg["MQTT_PASS"] = "Gakoa";
  Blockly.Msg["MQTT_PORT"] = "Ataka";
  Blockly.Msg["MQTT_PUB"] = "Argitaratu";
  Blockly.Msg["MQTT_SUB"] = "Harpidetu";
  Blockly.Msg["MQTT_TOPIC"] = "Gaia";
  Blockly.Msg["MQTT_USER"] = "Erabiltzailea";
  Blockly.Msg["MQTT_VALUE"] = "Balioa";
  Blockly.Msg["MQTT_WIFI_NAME"] = "Sarea";
  Blockly.Msg["MQTT_WIFI_PASS"] = "Gakoa";

  // Blocks - INFRARED
  Blockly.Msg["IR"] = "IG";
  Blockly.Msg["IR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IR_RX"] = "Hargailua";
  Blockly.Msg["IR_RX_NUMBER"] = "Jaso zenbakia hemen";
  Blockly.Msg["IR_TX"] = "Igorlea";
  Blockly.Msg["IR_TX_BITS"] = "#Bits";
  Blockly.Msg["IR_TX_CODE"] = "Kodea";
  Blockly.Msg["IR_TX_DATA"] = "Datua";
  Blockly.Msg["IR_TX_NUMBER"] = "Igorri zenbakia hemen";
  Blockly.Msg["IR_TX_PROTOCOL"] = "Protokoloa";

  // Workspace
  Blockly.Msg["ADD_COMMENT"] = "Gehitu iruzkina";
  Blockly.Msg["UNDO"] = "Desegin";
  Blockly.Msg["REDO"] = "Berregin";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "Badago '%1’ izena duen aldagaia.";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "Badago '%1’ izena duen aldagai bat '%2' motakoa.";
  Blockly.Msg["CHANGE_VALUE_TITLE"] = "Aldatu balioa:";
  Blockly.Msg["CLEAN_UP"] = "Ordenatu blokeak";
  Blockly.Msg["COLLAPSE_ALL"] = "Bildu blokeak";
  Blockly.Msg["COLLAPSE_BLOCK"] = "Bildu blokea";
  Blockly.Msg["DELETE_ALL_BLOCKS"] = "%1 bloke guztiak ezabatu?";
  Blockly.Msg["DELETE_BLOCK"] = "Ezabatu blokea";
  Blockly.Msg["DELETE_X_BLOCKS"] = "Ezabatu %1 bloke";
  Blockly.Msg["DELETE_VARIABLE"] = "Ezabatu '%1'";
  Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "'%2' aldagaiaren %1 erabilera ezabatu?";
  Blockly.Msg["DISABLE_BLOCK"] = "Desaktibatu blokea";
  Blockly.Msg["DUPLICATE_BLOCK"] = "Bikoiztu";
  Blockly.Msg["DUPLICATE_COMMENT"] = "Bikoiztu iruzkina";
  Blockly.Msg["ENABLE_BLOCK"] = "Aktibatu blokea";
  Blockly.Msg["EXPAND_ALL"] = "Zabaldu blokeak";
  Blockly.Msg["EXPAND_BLOCK"] = "Zabaldu blokea";
  Blockly.Msg["EXTERNAL_INPUTS"] = "Kanpoko sarrerak";
  Blockly.Msg["HELP"] = "Laguntza";
  Blockly.Msg["INLINE_INPUTS"] = "Lineako sarrerak";
  Blockly.Msg["NEW_VARIABLE"] = "Sortu…";
  Blockly.Msg["NEW_VARIABLE_TITLE"] = "Aldagai berriaren izena:";
  Blockly.Msg["REMOVE_COMMENT"] = "Ezabatu iruzkina";
  Blockly.Msg["RENAME_VARIABLE"] = "Aldatu izena…";
  Blockly.Msg["RENAME_VARIABLE_TITLE"] = '«%1» aldagai guztiei izena aldatu eta hau jarri:';
  Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Zure iruzkina…";

  // Backpack
  Blockly.Msg["COPY_ALL_TO_BACKPACK"] = "Kopiatu bloke guztiak motxilara";
  Blockly.Msg["COPY_TO_BACKPACK"] = "Kopiatu motxilara";
  Blockly.Msg["EMPTY_BACKPACK"] = "Hutsik";
  Blockly.Msg["PASTE_ALL_FROM_BACKPACK"] = "Kopiatu bloke guztiak motxilara";
  Blockly.Msg["REMOVE_FROM_BACKPACK"] = "Ezabatu motxilatik";

  return Blockly.Msg;
}
